import React, { useEffect, useState } from "react";
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, IconButton, Tooltip, Alert } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { getUsers } from "../services/api";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";

const API = "https://api.miksanplastik.com.tr";

export default function PendingUsers() {
  const [users, setUsers] = useState([]);
  const load = () => getUsers().then(r => setUsers(r.data.filter(u => u.status === "pending_approval"))).catch(() => {});
  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    try {
      const token = localStorage.getItem("token");
      await axios.put(`${API}/api/users/${id}/approve`, {}, { headers: { Authorization: `Bearer ${token}` } });
      toast.success("Kullanici onaylandi ve bilgilendirildi!");
      load();
    } catch { toast.error("Hata olustu"); }
  };

  const reject = async (id) => {
    try {
      const token = localStorage.getItem("token");
      await axios.put(`${API}/api/users/${id}/reject`, {}, { headers: { Authorization: `Bearer ${token}` } });
      toast.success("Kullanici reddedildi");
      load();
    } catch { toast.error("Hata olustu"); }
  };

  return (
    <Box>
      <Toaster />
      <Box display="flex" alignItems="center" gap={2} mb={3}>
        <Typography variant="h5" fontWeight={700}>Yeni Musteri Onaylari</Typography>
        <Chip label={users.length + " bekliyor"} color="warning" />
      </Box>
      {users.length === 0 ? (
        <Alert severity="success">Onay bekleyen musteri yok!</Alert>
      ) : (
        <TableContainer component={Paper} sx={{ maxHeight: "calc(100vh - 220px)" }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {["Ad Soyad","E-posta","Telefon","Firma","Vergi No / TC","İşlem"].map(h => (
                  <TableCell key={h} sx={{ bgcolor: "#FFF8E1", fontWeight: 700 }}>{h}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map(u => (
                <TableRow key={u.id} hover sx={{ bgcolor: "#FFFDE7" }}>
                  <TableCell>{u.name}</TableCell>
                  <TableCell>{u.email}</TableCell>
                  <TableCell>{u.phone || "-"}</TableCell>
                  <TableCell>{u.company || "-"}</TableCell>
                  <TableCell>{u.tax_no || u.tc_no || "-"}</TableCell>
                  <TableCell>
                    <Tooltip title="Onayla">
                      <IconButton color="success" onClick={() => approve(u.id)}>
                        <CheckCircleIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Reddet">
                      <IconButton color="error" onClick={() => reject(u.id)}>
                        <CancelIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}